import { useEffect } from "react";
import { dark, ligth } from "../const/colors/colorMode";

//Custom Hook para actualizar las variables en el CSS de App.css, con los colores del modo oscuro o claro.

const useThemeMode = ({ mode }) => {
    const actualizarRootStyles = () => {
        //Actualizar las variables de RGB del :root y sustituirlos por los del nuevo Tema.
        if (mode === "dark") {
            console.log("voy a cambiar el color", mode)
            document.documentElement.style.setProperty('--bg-color-by-mode', dark.bg);
            document.documentElement.style.setProperty('--bg-inbox-by-mode', dark.bg_inbox_dark_mode);
            document.documentElement.style.setProperty('--bg-border-by-mode', dark.bg_border_dark_mode);
            document.documentElement.style.setProperty('--bg-border-ligth-by-mode', dark.bg_border_dark_ligth_mode);
            document.documentElement.style.setProperty('--bg-sercher-by-mode', dark.bg_searcher_dark_mode);
            document.documentElement.style.setProperty('--bg-hover-by-mode', dark.bg_hover_dark_mode);
            document.documentElement.style.setProperty('--bg-text-inbox-by-mode', dark.bg_text_inbox_dark_mode);
            document.documentElement.style.setProperty('--bg-chat-by-mode', dark.bg_chat_bg_dark_mode);
            document.documentElement.style.setProperty('--bg-session-duration-by-mode', dark.bg_session_duration_dark_mode);
            document.documentElement.style.setProperty('--bg-text-inCourse-by-mode', dark.bg_session_inCourse_dark_mode);
        }
        else if (mode === "ligth") {
            document.documentElement.style.setProperty('--bg-color-by-mode', ligth.bg);
            document.documentElement.style.setProperty('--bg-inbox-by-mode', ligth.bg_inbox_ligth_mode);
            document.documentElement.style.setProperty('--bg-border-by-mode', ligth.bg_border_ligth_mode);
            document.documentElement.style.setProperty('--bg-border-ligth-by-mode', ligth.bg_border_ligth_ligth_mode);
            document.documentElement.style.setProperty('--bg-sercher-by-mode', ligth.bg_searcher_ligth_mode);
            document.documentElement.style.setProperty('--bg-hover-by-mode', ligth.bg_hover_ligth_mode);
            document.documentElement.style.setProperty('--bg-text-inbox-by-mode', ligth.bg_text_inbox_ligth_mode);
            document.documentElement.style.setProperty('--bg-chat-by-mode', ligth.bg_chat_bg_ligth_mode);
            document.documentElement.style.setProperty('--bg-session-duration-by-mode', ligth.bg_session_duration_ligth_mode);
            document.documentElement.style.setProperty('--bg-text-inCourse-by-mode', ligth.bg_session_inCourse_ligth_mode);
        }
    };

    useEffect(() => {
        actualizarRootStyles();
    }, [mode]);

};

export default useThemeMode;
